import { SET_LANGUAGE, SET_PAGE_TITLE, UPDATE_THEME_SETTINGS } from '../actionTypes'

import AppLocale from '../../lang'

const getSettings = () => ({
  // Layout navbar color
  // fig value
  navbarBg: 'success', //settings.getOption('navbarBg') || 'navbar-theme',

  // Layout sidenav color
  sidenavBg: 'dark', //settings.getOption('sidenavBg') || 'sidenav-theme',

  // Layout footer color
  footerBg: 'footer-theme', //settings.getOption('footerBg') || 'footer-theme',

  theme: 'theme-cotton',

  material: 'false',

  locale: 'th-TH',

  messages: AppLocale.th.messages,

  title: '',
})

const initialState = getSettings()

export default function (state = initialState, action) {
  let setting = getSettings()

  switch (action.type) {
    // set language
    case SET_LANGUAGE:
      // return { ...state, locale: action.payload };

      setting.locale = action.payload
      setting.messages = action.payload === 'en-US' ? AppLocale.en.messages : AppLocale.th.messages
      // setting.title = state.title
      // //console.log(setting);
      return setting

    case SET_PAGE_TITLE:
      //setting.title = action.payload;
      let tmp = { ...action.setting }
      tmp.title = action.payload
      setting = tmp
      // setting.title = action.payload;
      return setting

    // Update settings
    case UPDATE_THEME_SETTINGS:
      // let setting = getSettings();
      //console.log(setting);
      return setting
  }

  return state
}
